// src/components/DateRange.tsx
import React from "react";
import DatePicker from "react-datepicker";
import { th } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

export type Props = {
  from: Date | null;                 // ✅ ให้ชื่อเป็น from
  to: Date | null;                   // ✅ ให้ชื่อเป็น to
  onChangeFrom: (d: Date | null) => void;
  onChangeTo: (d: Date | null) => void;
  className?: string;
};

export default function DateRange({
  from, to, onChangeFrom, onChangeTo, className
}: Props): JSX.Element {
  return (
    <div className={`d-flex gap-2 flex-wrap ${className ?? ""}`}>
      <DatePicker
        selected={from}
        onChange={onChangeFrom}
        dateFormat="dd/MM/yyyy"
        placeholderText="วัน/เดือน/ปี (ตั้งแต่)"
        locale={th}
        isClearable
        className="form-control"
      />
      <DatePicker
        selected={to}
        onChange={onChangeTo}
        dateFormat="dd/MM/yyyy"
        placeholderText="วัน/เดือน/ปี (ถึง)"
        locale={th}
        isClearable
        className="form-control"
      />
    </div>
  );
}
